import React, {useState, useEffect} from "react";
import "./TopMenu.css";

interface TopMenuProps {
    onSelectionChange: (selectedOptions: string[]) => void;
    onDatasetChange: () => void;
}

const TopMenu: React.FC<TopMenuProps> = ({onSelectionChange, onDatasetChange}) => {
    const datasetOptions = ["Original", "Masked", "Splitted"];
    const datasetPartOptions = ["First", "Second", "Both"];
    const modelOptions = ["ResNet50", "InceptionV3", "MobilenetV2", "Vgg16", "CLIP"];
    const projectionOptions = ["uMAP", "tSNE", "PCA"];

    const modelLayersMapping: { [key: string]: string[] } = {
        "ResNet50": ["Layer 1", "Layer 2", "Layer 3", "Layer 4"],
        "InceptionV3": ["Layer A", "Layer B", "Layer C"],
        "MobilenetV2": ["Layer X", "Layer Y", "Layer Z"],
        "Vgg16": ["Layer Alpha", "Layer Beta", "Layer Gamma"],
        "CLIP": ["Layer I", "Layer II", "Layer III"]
    };

    const [modelLayers, setModelLayers] = useState<string[]>(modelLayersMapping[modelOptions[0]]);
    const [selectedOptions, setSelectedOptions] = useState<string[]>([
        datasetOptions[0],
        datasetPartOptions[0],
        modelOptions[0],
        modelLayers[0],
        projectionOptions[0]
    ]);

    const allOptions = [datasetOptions, datasetPartOptions, modelOptions, modelLayers, projectionOptions];

    useEffect(() => {
        onSelectionChange(selectedOptions);
    }, [selectedOptions, onSelectionChange]);

    const handleSelect = ({index, value}: { index: number, value: string }) => {
        const updatedOptions = [...selectedOptions];
        updatedOptions[index] = value;
        setSelectedOptions(updatedOptions);

        if (index === 2) {
            const newModelLayers = modelLayersMapping[value] || [];
            setModelLayers(newModelLayers);
            updatedOptions[3] = newModelLayers[0];
            setSelectedOptions(updatedOptions);
        }

        if (index === 0 || index === 1) {
            onDatasetChange();
        }
    };

    return (
        <div className="top-menu">
            {allOptions.map((options, i) => (
                <div className="dropdown" key={i}>
                    <select
                        value={selectedOptions[i]}
                        onChange={(e) => handleSelect({index: i, value: e.target.value})}
                    >
                        {options.map((option, idx) => (
                            <option value={option} key={idx}>
                                {option}
                            </option>
                        ))}
                    </select>
                </div>
            ))}
        </div>
    );
};

export default TopMenu;